module.exports = __webpack_public_path__ + "static/img/doudizhujishu.0caddb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/doudizhujishu.png
// module id = YIAk
// module chunks = 0